import { jsx as _jsx } from "react/jsx-runtime";
export const CheckS = ({ color = 'currentColor', ...props })=>/*#__PURE__*/ _jsx("svg", {
        fill: "none",
        height: "24",
        viewBox: "0 0 24 24",
        width: "24",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ _jsx("path", {
            d: "M20.7037 4.15241C21.0421 4.40929 21.0898 4.89062 20.8483 5.2032L10.5982 18.7033C10.3164 19.0586 9.82783 19.0969 9.50542 18.8136L3.25538 13.3136C2.95325 13.0469 2.90746 12.5731 3.18702 12.255C3.46772 11.936 3.94149 11.9219 4.24562 12.1866L9.89018 17.1535L19.6529 4.29694C19.8945 3.97266 20.3661 3.89642 20.7037 4.15241Z",
            fill: color
        })
    });

//# sourceMappingURL=check-s.js.map